import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {ModalLayout} from '@appbase/templates'
import api from '@board/api'
import * as dateHelper from '@appbase/util/date-helper'
import { open, OpenType } from '@board/open-handler'; 
import { mapActions, mapGetters } from 'vuex'
import * as types from '@board/store/types'
import { createEventBus, removeEventBus } from '@appbase/util/eventBus'

@Component({
    components: {
    ModalLayout,
        
    },
    computed: mapGetters({
        popupBaseUrl: types.POPUP_BASEURL,
    }),

    methods: mapActions({

    })
})
export default class ReservedArticlesModal extends Vue {
    @Prop({ type: Number }) boardId !: number

    reservedArticles:article.Article[]=[]
    popupBaseUrl!: string;
    selectedArticles:number[] = []
    selectedAll:boolean=false

    handleClose() {
        this.closeCurrentModal()
      }

    convertDateFormat(val:string){
        return dateHelper.uGetDateFormat('yyyy-MM-dd',new Date(val));
    }
    
    convertReservedDateFormat(val:string){
        return dateHelper.uGetDateFormat('yyyy-MM-dd H:i',new Date(val));
    }

    articleOpen(article:article.Article){
        if(this.isTeams) this.handleClose()
        open(!this.isTeams ? 
            OpenType.PopupWrite : OpenType.ModalWrite,
            {
                boardId: article.boardId,
                baseUrl: this.popupBaseUrl,
                query:{'ARTICLEID':article.articleId.toString(),'reserved':'true'} 
            });   
    }

    articleload(){
        api.article.getReservedArticleList(this.boardId).then(res=>{
            this.reservedArticles=res.map(i=>{return {...i,selected:false}})

        })
    }

    async deleteReservedArticle(articleId:string){
        if(await (window as any).confirmAsync('삭제_하시겠습니까')){
            api.article.deleteReservedArticles(articleId).then(async res=>{
                if(res>0){
                    (window as any).alertAsync(this.$t('삭제_되었습니다').toString())
                    this.articleload();
                }
            })
        }
    }

    selectAllArticles(){
        if(!this.selectedAll){
            var str = ''
            this.reservedArticles.map((i:any)=>{
                i.selected = true;
                return str+=i.articleId.toString()+','
            })
            if(str.endsWith(',')){
                str = str.slice(0,-1)
            }
        }
        else{
            this.reservedArticles.map((i:any)=>i.selected=false)
        }
        this.selectedAll=!this.selectedAll
    }

    async deleteSelectedArticle(){
        var str = ''
        this.reservedArticles.filter((i:any)=>i.selected).map(ii=> str +=ii.articleId.toString()+',')
        if(str.endsWith(','))
            str = str.slice(0,-1)
        await this.deleteReservedArticle(str)
    }

    postSelectedArticle(){
        var str = ''
        this.reservedArticles.filter((i:any)=>i.selected).map(ii=> str +=ii.articleId.toString()+',')
        if(str.endsWith(','))
            str = str.slice(0,-1)
        api.article.postReservedArticles(str,this.boardId).then(res=>{
            if(res>0)
                this.articleload()
        })
    }

    created(){
        if(this.boardId){
            this.articleload()
        }
        createEventBus(window, 'boardlist-reload', this.articleload)

    }
    beforeDestroy() {
        removeEventBus(window, 'boardlist-reload', this.articleload)
    }
}
